import { graphql } from "@/gql";
import { ResultOf } from "@graphql-typed-document-node/core";

export const relocationPromotionListQuery = graphql(`
  query RelocationPromotionList(
    $first: Int!
    $page: Int
    $supplier_id: ID
    $active: Boolean
    $orderBy: [QueryRelocationPromotionsOrderByOrderByClause!]
  ) {
    relocationPromotions(
      first: $first
      page: $page
      supplier_id: $supplier_id
      active: $active
      orderBy: $orderBy
    ) {
      data {
        id
        budget_amount
        impressions
        clicks
        conversions
        spend_amount
        created_at
        creative {
          title
          body
          target_url
          image_url
        }
        relocation {
          id
          name
          reference
          supplier {
            id
            name
          }
        }
        channels {
          id
          platform
          status
          budget_amount
          impressions
          clicks
          conversions
          spend_amount
          last_synced_at
          manager_url
        }
      }
      paginatorInfo {
        ...PaginationFields
      }
    }
  }
`);

export type PromotionListItem = NonNullable<
  ResultOf<typeof relocationPromotionListQuery>["relocationPromotions"]
>["data"][number];

export type PromotionListChannel = PromotionListItem["channels"][number];
